import { render, staticRenderFns } from "./PlanejamentoAcaoFormRodape.vue?vue&type=template&id=4951da86"
import script from "./PlanejamentoAcaoFormRodape.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoFormRodape.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoFormRodape.vue?vue&type=style&index=0&id=4951da86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports